import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { motion } from "framer-motion";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

// Icons
import { FaPlane, FaHotel, FaBus, FaHiking, FaBriefcase, FaHeadset, FaArrowRight } from "react-icons/fa";

import Navr from "../Navbar/Navr";
import Footer from "./Footer";

// Images
import custom from '../Ecomphotos/custom.jpg';
import resort from '../Ecomphotos/resort.jpg';
import train from '../Ecomphotos/train1.jpg';
import adventure from '../Ecomphotos/adventure.jpg';
import corporate from '../Ecomphotos/corporate.jpg';
import watch from '../Ecomphotos/watch.jpg';

const services = [
  {
    id: 1,
    title: "Customized Tour Packages",
    desc: "We design travel plans that fit your budget, interests, and preferences, ensuring a personalized experience.",
    img: custom,
    icon: <FaPlane />,
  },
  {
    id: 2,
    title: "Hotel & Resort Booking",
    desc: "Comfortable stays with the best facilities at handpicked hotels and resorts across destinations.",
    img: resort,
    icon: <FaHotel />,
  },
  {
    id: 3,
    title: "Transportation Services",
    desc: "From flights to local cabs, we arrange all your travel needs with ease and reliability.",
    img: train,
    icon: <FaBus />,
  },
  {
    id: 4,
    title: "Adventure & Activities",
    desc: "Enjoy trekking, river rafting, cultural shows, and many other exciting adventures.",
    img: adventure,
    icon: <FaHiking />,
  },
  {
    id: 5,
    title: "Corporate & Group Tours",
    desc: "Seamless planning for large groups, conferences, and corporate retreats with maximum comfort.",
    img: corporate,
    icon: <FaBriefcase />,
  },
  {
    id: 6,
    title: "24x7 Travel Assistance",
    desc: "Round-the-clock support to make sure your journey remains smooth and worry-free.",
    img: watch,
    icon: <FaHeadset />,
  },
];

export default function Services() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="services-page">
      <Navr />

      {/* --- Section 1: Hero Banner --- */}
      <div className="service-hero d-flex align-items-center justify-content-center" style={{ backgroundImage: `url(${custom})` }}>
        <div className="hero-overlay"></div>
        <Container className="text-center position-relative z-2">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h5 className="text-warning text-uppercase ls-2 mb-3">What We Do</h5>
            <h1 className="display-4 fw-bold text-white mb-4">World-Class Services</h1>
            <p className="text-white lead mx-auto opacity-75" style={{ maxWidth: "700px" }}>
              Experience seamless travel planning with Jawali Holidays.
            </p>
          </motion.div>
        </Container>
      </div>

      {/* --- Section 2: Intro --- */}
      <section className="py-5 bg-white text-center">
        <Container>
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <h6 className="text-danger fw-bold text-uppercase">Our Expertise</h6>
              <h2 className="fw-bold mb-4">Comprehensive Travel Solutions</h2>
              <div className="separator mx-auto mb-4"></div>
              <p className="text-muted lead-sm">
                At <strong>Jawali Holidays</strong>, we go beyond just booking tickets. We curate experiences. 
                Whether you need a luxury resort, a rugged adventure, or a seamless corporate retreat, we handle every detail so you can focus on making memories.
              </p>
            </div>
          </div>
        </Container>
      </section>

      {/* --- Section 3: Services Grid --- */}
      <section className="py-5 bg-light">
        <Container>
          <Row className="g-4">
            {services.map((service, i) => (
              <Col md={6} lg={4} key={service.id} data-aos="fade-up" data-aos-delay={i * 100}>
                <div className="service-card h-100">
                  
                  {/* Image Header */}
                  <div className="service-img-wrapper">
                    <img src={service.img} alt={service.title} />
                    <div className="service-overlay"></div>
                    
                    {/* Floating Icon */}
                    <div className="floating-icon">
                      {service.icon}
                    </div>
                  </div>

                  {/* Content */}
                  <div className="service-body p-4 text-center mt-3">
                    <h5 className="fw-bold mb-3">{service.title}</h5>
                    <p className="text-muted small mb-4">{service.desc}</p>
                    <Link to="/contact" className="btn-link-custom">
                      Book Now <FaArrowRight className="ms-1" size={12} />
                    </Link>
                  </div>

                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* --- Section 4: CTA Strip --- */}
      <section className="py-5 bg-dark text-white text-center">
         <Container>
            <h2 className="fw-bold mb-3">Need a Custom Package?</h2>
            <p className="text-white-50 mb-4">We can tailor any service to your specific needs.</p>
            <Link to="/contact" className="btn btn-danger rounded-pill px-5 py-3 fw-bold shadow-lg hover-scale">
               Get a Free Quote
            </Link>
         </Container>
      </section>

      <Footer />
    </div>
  );
}